import { createWebHistory, createRouter } from "vue-router";
import Home from "@/components/HomePage.vue";
import Tariff from "@/components/TariffPage.vue";
import BlogList from "@/components/BlogList.vue";
import BlogPage from "@/components/BlogPage.vue";
import Consult from "@/components/ConsultPage.vue";
import Native from "@/components/NativeAds.vue";
import Video from "@/components/VideoAds.vue";
import Banner from "@/components/BannerAds.vue";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    props: true,
    meta: {
      title: "سرویس تبلیغات آنلاین (ویدیویی و بنری) | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/tariff",
    name: "Tariff",
    component: Tariff,
    props: true,
    meta: {
      title: "تعرفه | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/blog",
    name: "BlogList",
    component: BlogList,
    props: true,
    meta: {
      title: "وبلاگ | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/blog/:p",
    name: "BlogPage",
    component: BlogPage,
    props: true,
  },

  {
    path: "/post/:p",
    redirect: to => {
        return { path: `/blog/${to.params.p}`};
    }
  },

  {
    path: "/contactUs",
    name: "Consult",
    component: Consult,
    props: true,
    meta: {
      title: "مشاوره رایگان | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/ads/native",
    name: "Native",
    component: Native,
    props: true,
    meta: {
      title: "تبلیغات همسان | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/ads/video",
    name: "Video",
    component: Video,
    props: true,
    meta: {
      title: "تبلیغات ویدیویی | آن‌کلیک",
      removeMenu: false,
    },
  },

  {
    path: "/ads/banner",
    name: "Banner",
    component: Banner,
    props: true,
    meta: {
      title: "تبلیغات بنری | آن‌کلیک",
      removeMenu: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: "smooth" };
    }
  },
});

router.afterEach((to) => {
  const defaultTitle = "آن‌کلیک";
  document.title = to.meta?.title || defaultTitle;
  const panelDomain = process.env.VUE_APP_ONCLICK_PANEL_DOMAIN;
  if (to.path === '/login') {
    window.location.href = `${panelDomain}/login`;
  }
  if (to.path === '/register') {
    window.location.href = `${panelDomain}/register`;
  }
});

export default router;